import React from "react";
import { Card } from "../modules/Crops/Tags";

export function CropTagCardPage(props) {
  return <Card {...props} />;
}
